// Wait until the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Locate the modal and the button to open it
  var modal = document.getElementById("modal_country_selector_top");
  var openButton = document.getElementById("country_selector_top");
  const navigateButton = document.querySelector(".js-ter-select-navigate");
  const closeBtn = modal.querySelector(".js-ter-select-close");
  const closeBtn2 = modal.querySelector(".close-btn");
  const niceSelector = document.querySelector("#nice-selector");
  navigateButton.addEventListener("click", function () {
    const url = niceSelector.getAttribute("data-url"); // Retrieve the stored URL
    if (url) {
      window.location.href = `${url}?relocate=true`; // Redirect to the URL
    } else {
      alert("No store selected!");
    }
  });

  // Check if modal exists and add event listeners only if it does
  if (modal && openButton) {
    // Function to open the modal
    function toggleModal() {
      if (modal.style.display === "block") {
        modal.style.display = "none";
      } else {
        modal.style.display = "block";
      }
    }

    // Function to close the modal if clicked outside
    function closeModal(event) {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    }

    // Add event listeners
    closeBtn2.addEventListener("click", () => {
      modal.style.display = "none";
    });
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
    });
    openButton.addEventListener("click", toggleModal); // Open modal
    window.addEventListener("click", closeModal); // Close modal when clicking outside
  } else {
    console.warn("Modal or open button not found.");
  }
});
